import React, { Fragment, MouseEvent } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import EstimateActionButtons from './EstimateActionButtons';
import EstimateFooter from './EstimateFooter';
import EstimateMessage from './EstimateMessage';

import { CheckoutPortalFormattedMessage } from 'components/Core/CheckoutPrtalForamattedMessage/CheckoutPortalFormattedMessage';
import Card from 'components/Shared/Card/Card';
import { getTxnTextBasedOnType } from 'shared/utils';
import { colors, fontSize, breakpoints } from 'styles/cp';

export interface Props {
  companyName: string;
  amount: number;
  currency: string;
  isPDFError: boolean;
  locale: string;
  pdfUrl?: string;
  // eslint-disable-next-line no-unused-vars
  acceptHandler: () => void;
  // eslint-disable-next-line no-unused-vars
  viewEstimateHandler: (event: MouseEvent) => void;
  isChangeOrder?: boolean;
  declineHandler: () => void;
}

const EstimateAccept: React.FC<Props> = ({
  companyName,
  pdfUrl,
  amount,
  currency,
  isPDFError,
  acceptHandler,
  isChangeOrder,
  declineHandler,
}: Props) => {
  const { transaction_text, Transaction_text } = getTxnTextBasedOnType(isChangeOrder);
  const transaction = (
    <FormattedMessage
      id={transaction_text}
      defaultMessage={transaction_text}
      values={{ transaction: transaction_text }}
    />
  );
  const Transaction = (
    <FormattedMessage
      id={Transaction_text}
      defaultMessage={Transaction_text}
      values={{ transaction: Transaction_text }}
    />
  );
  return (
    <Fragment>
      <Card>
        <div className="main">
          <h2 className="company-name">{companyName}</h2>
          <span className="payment-amount-label">
            <FormattedMessage
              id="ESTIMATE_TOTAL_TEXT"
              defaultMessage="{Transaction} Total"
              values={{ Transaction }}
            />
          </span>
          <span className="payment-amount">
            <FormattedNumber value={amount} style="currency" currency={currency} />
          </span>
          <div className="view-estimate-action">
            <EstimateMessage
              pdfUrl={pdfUrl}
              isPDFError={isPDFError}
              isChangeOrder={isChangeOrder}
            />
          </div>
          <div className="message" data-testid="test-merchant-message">
            <CheckoutPortalFormattedMessage
              id="ESTIMATE_MERCHANT_PENDING_MESSAGE"
              defaultMessage="To move forward with this {transaction}, select <b>Accept</b> and {companyName} will reach out with next steps."
              values={{
                companyName: companyName,
                transaction: transaction,
                b: (chunks: string) => <b>{chunks}</b>,
              }}
            />
            <br />
          </div>
          <EstimateActionButtons acceptHandler={acceptHandler} declineHandler={declineHandler} />
        </div>

        <EstimateFooter isChangeOrder={isChangeOrder} />
      </Card>

      <style jsx>{`
        text-align: center;
        .main {
          padding: 40px 98px 0;
          @media screen and (max-width: ${breakpoints.md}) {
            padding: 32px 16px 20px;
          }

          .view-estimate-action {
            display: none;
            @media screen and (max-width: ${breakpoints.md}) {
              display: block;
            }
          }
        }

        .company-name {
          font-size: ${fontSize.ml};
          margin: 0 0 34px;
        }

        .payment-amount-label {
          font-family: AvenirNextforINTUIT-Regular;
          font-size: ${fontSize.xxs};
          color: ${colors.whiteGray};
          text-transform: uppercase;
          display: block;
          padding-bottom: 8px;
        }

        .payment-amount {
          font-family: AvenirNextforINTUIT-Demi;
          font-size: ${fontSize.lg};
          line-height: 36px;
          color: ${colors.darkGray};
          text-transform: uppercase;
          display: block;
        }

        .message {
          font-size: ${fontSize.xs};
          color: ${colors.gray02};
          padding: 26px 0 44px;
        }
      `}</style>
    </Fragment>
  );
};

export { EstimateAccept };

// @ts-ignore
export default EstimateAccept;
